import { Component } from '@angular/core';

@Component({
  selector: 'mfp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor() { }
}
